"use strict";
exports.__esModule = true;
function formatCell(val, decimalPoint) {
    if (typeof val === 'undefined' || val === null) {
        return '""';
    }
    var str = val.toString().trim();
    if (!isNaN(val)) {
        return str.replace('.', decimalPoint);
    }
    return "\"" + str + "\"";
}
var ProgramOverviewDataPreparer = /** @class */ (function () {
    function ProgramOverviewDataPreparer(config) {
        this.config = config;
    }
    ProgramOverviewDataPreparer.prototype.makeFirstTableData = function () {
        var data = [];
        for (var i = 0; i < this.config.FirstTableData.length; i++) {
            data.push(this.config.FirstTableData[i]['Display']);
            data.push(this.config.FirstTableData[i]['Val']);
        }
        var firstTableData = [];
        var noOfCols = (this.config.NumberOfColumns - 1) * 2;
        for (var i = 0; i < data.length; i += noOfCols) {
            firstTableData.push(data.slice(i, i + noOfCols));
        }
        if (!this.isHigherLevel()) {
            var treeValNames = Object.keys(this.config.TreeVal);
            for (var i = 0; i < treeValNames.length; i++) {
                firstTableData[i].unshift(this.config.TreeVal[treeValNames[i]]);
                firstTableData[i].unshift(treeValNames[i]);
            }
        }
        return firstTableData;
    };
    ProgramOverviewDataPreparer.prototype.isHigherLevel = function () {
        return !(this.config.TreeVal.constructor === Object &&
            Object.entries(this.config.TreeVal).length !== 0);
    };
    ProgramOverviewDataPreparer.prototype.roundTo = function (num, decimal) {
        var d = Math.pow(10, decimal);
        return Math.round(num * d) / d;
    };
    ProgramOverviewDataPreparer.prototype.roundTableData = function (tableData, tableType, noOfDecimals) {
        for (var i = 0; i < tableData.length; i++) {
            var n = 0;
            if (tableType == "second") {
                n = tableData[i].length;
            }
            else if (tableType == "third") {
                n = Object.keys(tableData[i]).length;
            }
            for (var j = 0; j < n; j++) {
                if (typeof tableData[i][j] == 'number') {
                    tableData[i][j] = this.roundTo(tableData[i][j], noOfDecimals);
                }
            }
        }
        return tableData;
    };
    ProgramOverviewDataPreparer.prototype.makeSecondTableData = function () {
        var secondTableData = [];
        for (var i = 0; i < this.config.MiddleTableRowHeaders.length; i++) {
            secondTableData.push([this.config.MiddleTableRowHeaders[i]]);
        }
        for (var i = 0; i < secondTableData.length; i++) {
            for (var j = 0; j < this.config.MiddleTableData[secondTableData[i][0]].length; j++) {
                secondTableData[i].push(this.config.MiddleTableData[secondTableData[i][0]][j]);
            }
        }
        var activeDatasetCol = secondTableData[0].indexOf("Active Project Dataset");
        if (secondTableData[0].indexOf(this.config.ActiveDatasetYear - 1 + " IIF Submission") > -1) {
            var archiveDatasetCol = secondTableData[0].indexOf(this.config.ActiveDatasetYear - 1 + " IIF Submission");
        }
        else {
            var archiveDatasetCol = secondTableData[0].indexOf(this.config.ActiveDatasetYear - 1 + " IIF Submission (Not Defined)");
        }
        if (activeDatasetCol > 1 && archiveDatasetCol > 0) {
            for (var i = 0; i < secondTableData.length; i++) {
                if (i == 0) {
                    secondTableData[i].push("Change", "Change (fraction)");
                }
                else {
                    var n = angular.copy(secondTableData[i][activeDatasetCol]);
                    var m = angular.copy(secondTableData[i][archiveDatasetCol]);
                    if (typeof (n) == "string") {
                        n = this.checkAndReplace(n);
                        m = this.checkAndReplace(m);
                    }
                    var change = Number(n - m);
                    if (m == 0) {
                        var fraction = 500;
                    }
                    else {
                        var fraction = Number(change / m);
                    }
                    if (secondTableData[i][0] == "Gross Margin % at the year of maximum revenue") {
                        secondTableData[i].push(change + "%", fraction);
                    }
                    else {
                        secondTableData[i].push(change, fraction);
                    }
                }
            }
        }
        return secondTableData;
    };
    ProgramOverviewDataPreparer.prototype.checkAndReplace = function (n) {
        if (typeof n == "string" && n.indexOf("%") > -1) {
            n = parseInt(n.replace("%", ""));
        }
        return n;
    };
    ProgramOverviewDataPreparer.prototype.makeThirdTableData = function () {
        var gridColumnHeaders = this.config.LastTableData[0];
        var colDef = gridColumnHeaders.map(function (header, index) {
            return {
                enableHiding: false,
                enableSorting: false,
                name: header,
                displayName: header,
                field: index.toString(),
                width: index === 3 ? 200 : 100,
                pinnedLeft: index === 0 || index == 1,
                cellClass: index === 0 ? "grid-row-header" : undefined,
                cellTemplate: '<div class="ui-grid-cell-contents">' +
                    '{{COL_FIELD}}' +
                    '</div>'
            };
        });
        var gridData = this.config.LastTableData.slice(1).map(function (row) {
            var rowData = {};
            row.forEach(function (cell, index) {
                rowData[index.toString()] = cell;
            });
            return rowData;
        });
        return {
            columnDefs: colDef,
            data: gridData
        };
    };
    ProgramOverviewDataPreparer.prototype.tableToCsv = function (tableData, format, program, header) {
        if (program === void 0) { program = null; }
        if (header === void 0) { header = null; }
        var decimalPoint = (format == 'EU' ? ',' : '.');
        var cellSeparator = (format == 'EU' ? ';' : ',');
        var rows = tableData.map(function (row, index) {
            var formattedCells = row.map(function (cell) { return formatCell(cell, decimalPoint); });
            var rowStr = formattedCells.join(cellSeparator);
            var rowHeader = (index === 0 ? header || '' : program);
            return program ? "\"" + rowHeader + "\"" + cellSeparator + rowStr : rowStr;
        });
        return rows.join('\n');
    };
    ProgramOverviewDataPreparer.prototype.getCsv = function (format) {
        if (format === void 0) { format = 'US'; }
        var firstTable = this.makeFirstTableData();
        var secondTable = this.makeSecondTableData();
        var thirdTable = this.config.LastTableData;
        var program = firstTable[0][1];
        return [
            this.tableToCsv(firstTable, format, program, 'Program'),
            this.tableToCsv(secondTable, format, program, ''),
            this.tableToCsv(thirdTable, format),
            "\"**First year at maturity, PM Expected Summary.\""
        ].join('\n\n');
    };
    return ProgramOverviewDataPreparer;
}());
exports.ProgramOverviewDataPreparer = ProgramOverviewDataPreparer;
//# sourceMappingURL=program-overview.logic.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/program-overview/program-overview.logic.js